<template>
 <div>

<ui-button-options v-on:click.native.stop.prevent="viewItem()" :title="title" :subtitle="computeExcerpt">
      
      <div slot="options" v-if="computeUserAccess">
        <ui-option title="language.edit" v-on:click.native.stop.prevent="editItem()" backgroundColor="#F2BC55" color="#FFFFFF" icon="pencil-alt"/>
        <ui-option title="language.delete" v-on:click.native.stop.prevent="deleteItem()" backgroundColor="#F46767" color="#FFFFFF" icon="times"/>
      </div>
    
   </ui-button-options>
</div>
</template>

<script>
import UiButtonOptions from '../UiButtonOptions.vue';
import UiOption from '../UiOption.vue';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import { mapState } from 'vuex';
import { helper } from '../../services/Helper.js';
import i18n from "../../language.js";


export default {
  name: 'button-calendar',
  props:{
    title:{default:"no-title"},
    subtitle:{default:"no-subtitle"},
    item_id:{default:0},
    imageUrl:{default:"no-url"},
    date:{default:""}, // its really the parent tile to identify parent of a calendar item.
    group_id:{default:0},
  },
  data:function(){
    return {
    }
  },
  computed:{
     ...mapState([
       'appSettings','group'
      ]),
      computeExcerpt(){
        var read_more=" ["+i18n.t('language.lees_meer')+"]"
        return helper.getExcerpt(this.subtitle,read_more);
      },
    computeUserAccess(){
      
        var isInGlobal=(this.$router.currentRoute.path=='/calendar');
        if(!this.group.authorized && !isInGlobal ){
           // if we are in group
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.NONE){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
           
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       }
  },
  methods:{
    editItem(){
      this.$router.push({path:'/calendar/'+this.item_id+'/update_item/'})
    },
    deleteItem(){
     
    var isInGlobal=(this.$router.currentRoute.path=='/calendar');


     var payload={
        id:this.item_id,
        date:this.date,
        cal_id:isInGlobal ? 0 : this.group.cal_id, // serves as a key for store array (cal_id 0 is global)
      }
      this.$store.dispatch('delete_calendar_item',payload);
    },
    viewItem(){
      this.$router.push({path:'/calendar_item/'+this.item_id})
    },
    imgLoadError(event){
      event.target.src=require('../../assets/thumb_404.png');
    },
  },
  mounted:function(){
    
  },
  components:{
    UiButtonOptions,
    UiOption
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img-icon{
  display:block;
  height: 25px;
  width: 25px;
  border-radius: 9999px;
}
</style>
